/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { useQuery, gql } from '@apollo/client';
import { handleApolloError } from '@exo/frontend-common-apollo';

export const FILTER_PRODUCTS = gql`
 query Products($filter: ProductFilter!) {
  products(filter: $filter) {
    edges {
      node {
        name
        fullImage
      }
    }
  }
}
`;

export const useGetCustomLineItemImage = (filter) => {
  const { loading, data, error } = useQuery(FILTER_PRODUCTS, {
    variables: {
      filter
    }
  });

  
  handleApolloError(__filename, error);

  return { loading, data: data, error };
};
